import { Type } from 'class-transformer';
import { Role } from '../role';
import { Organization } from '../organization';

export class SelectableRole {
	@Type(() => Organization)
	organization: Organization;

	type: 'parent' | 'child';

	@Type(() => Role)
	roles: Role[];
}
